'use client';

import { useState } from 'react';
import Link from 'next/link';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { siteStatic } from '@/content/siteStatic';
import { PageContainer } from '@/components/layout/PageContainer';

export function MarketingFooter() {
  const { footer } = siteStatic;
  const [openQnaIndex, setOpenQnaIndex] = useState<number | null>(null);

  const toggleQna = (index: number) => {
    setOpenQnaIndex(openQnaIndex === index ? null : index);
  };

  return (
    <footer className="bg-gray-50 border-t-2 border-gray-200 mt-auto">
      <PageContainer verticalSpacing="lg">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{footer.about.title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              {footer.about.text}
            </p>
          </div>

          {/* Q&A */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{footer.qna.title}</h3>
            <div className="space-y-3">
              {footer.qna.items.map((item, index) => (
                <div key={index} className="border-b border-gray-200 last:border-0 pb-3 last:pb-0">
                  <button
                    onClick={() => toggleQna(index)}
                    className="w-full text-left flex items-center justify-between gap-2 py-2 text-sm font-medium text-gray-700 hover:text-[#10b981] transition-colors"
                  >
                    <span>{item.q}</span>
                    {openQnaIndex === index ? (
                      <ChevronUp className="h-4 w-4 flex-shrink-0 text-gray-400" />
                    ) : (
                      <ChevronDown className="h-4 w-4 flex-shrink-0 text-gray-400" />
                    )}
                  </button>
                  {openQnaIndex === index && (
                    <p className="text-sm text-gray-600 mt-2 pl-0 pb-2 leading-relaxed">
                      {item.a}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{footer.links.title}</h3>
            <ul className="space-y-3 text-sm">
              {footer.links.items.map((link, index) => (
                <li key={index}>
                  <Link
                    href={link.href}
                    className="text-gray-600 hover:text-[#10b981] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacts */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{footer.contacts.title}</h3>
            <ul className="space-y-3 text-sm mb-4">
              {footer.contacts.items.map((contact, index) => (
                <li key={index}>
                  <a
                    href={contact.href}
                    className="text-gray-600 hover:text-[#10b981] transition-colors"
                  >
                    {contact.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-xs text-gray-500 leading-relaxed">
              {footer.contacts.note}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-500">
            {footer.bottom}
          </p>
        </div>
      </PageContainer>
    </footer>
  );
}

